import isTableConfig from 'notebook/structured-tables/util/isTableConfig';
import {StructuredTableToTableMetadata, Table} from 'notebook/tables/TableConstants';
import APIUtil from 'util/APIUtil';

/**
 * Computes whether the given table is a table in config mode in a template.
 *
 * @param table - The table to check
 * @param editorContextIsConfig - isConfig from EditorPropertiesContext (the parent document/entry context)
 * @param fileIsConfigProp - fileIsConfig prop passed directly to TableEditable
 */
export function computeIsConfigTable(
  table: Table,
  editorContextIsConfig: boolean,
  fileIsConfigProp?: boolean
): boolean {
  const metadata = table.metadata as StructuredTableToTableMetadata<unknown>;
  return (
    metadata?.isConfig ||
    isTableConfig(table._tableType) ||
    Boolean(table.fileId && APIUtil.isConfigurationDocument(table.fileId)) ||
    editorContextIsConfig ||
    Boolean(fileIsConfigProp)
  );
}

export function computeTableProvenanceUuid(
  tableProvenanceUuid: string | null | undefined,
  proxyProvenanceUuid: string | null | undefined
): string | null {
  return tableProvenanceUuid ?? proxyProvenanceUuid ?? null;
}
